var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"tab-item pa-3 pt-5",attrs:{"align":"stretch"}},[_c('v-col',{staticClass:"pa-8 py-6"},[_c('ParameterInput',{attrs:{"parameter":_vm.Head}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }